import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
`;

export const Content = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const TicketList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
`;

export const TicketCard = styled.div`
  cursor: pointer;

  .ant-card-body {
    display: flex;
    background: #f9f9f9;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 12px;
    color: #8c8c8c;
  }

  .ant-card-meta {
    margin-bottom: 16px;
  }

  .ticket-info {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 16px;
  }
`;

export const TicketView = styled.div`
  background: #f9f9f9;
  padding: 24px;
  border-radius: 8px;
`;

export const TicketViewHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  h2 {
    margin: 0 16px;
  }

  .ticket-actions {
    margin-left: auto;
  }
`;

export const TicketViewBody = styled.div`
  .chat-window-body {
    flex-grow: 1;
    overflow-y: auto;
    padding: 8px 16px;
    height: 400px; // or some appropriate height
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin-top: 16px;
  }

  .message {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  .message-timestamp {
    font-size: 0.75rem;
    color: #65676b;
    margin-top: 4px;
  }

  .message-content {
    padding: 8px 12px;
    border-radius: 18px;
    max-width: 80%;
    width: fit-content;
  }

  .message.sent {
    align-items: flex-end;
  }

  .message.sent .message-content {
    background-color: #008037;
    color: white;
  }

  .message.sent .message-timestamp {
    align-self: flex-end;
  }

  .message.received {
    align-items: flex-start;
  }

  .message.received .message-content {
    background-color: #f0f2f5;
    color: #050505;
  }

  .chat-footer {
    padding-top: 16px;
  }
`;
